<template>
  <div id="shop">

      <!-- Keepalive will ensure that product listings and search results pages are kept 
      so if the user goes back they retain their scroll position, and the page doesn't have to load again-->
      <!-- <transition name="fade"> -->
        <!-- :include="['SearchResults', 'ProductListing']" -->
        <keep-alive  :include="['SearchResults', 'ProductListing']" :max="2">
          <!-- Key ensures components aren't reused when parameters have changed -->
          <router-view :key="$route.params.product + ' ' + $route.params.subcategory + ' ' + $route.params.category"></router-view>
          <!-- /> -->
        </keep-alive>
      <!-- </transition> -->
  </div>
</template>

<script>

export default {
  name: "ViewShop",
  components: {
  },
  created() {
    //fetch reference before shop page loads
    this.$store.dispatch("member/getCachedMemberDetails");
    //get favourites too
    this.$store.dispatch("favourites/getCachedFavourites")

    //cart fetched at higher level
  }
};
</script>

<style lang="scss">

</style>

